import { RouteConfig, Route, NavigationGuardNext } from "vue-router";
const clientData = () => import("./quote/ClientData.vue");
const FinalPayment = () => import("./quote/finalPayment.vue");
const urbanMobilitySummary = () => import("./quote/mobilitySummary.vue");
const tabOneWelcome = () => import("./quote/views/tab-one.vue");
const tabTwoMobility = () => import("./quote/views/tab-two.vue");
const tabThreeRange = () => import("./quote/views/tab-three.vue");
const tabFourPlans = () => import("./quote/views/tab-four.vue");
const pageTitle = 'Cotizá tu seguro de Bici o Monopatín | Sancor Seguros';
const contentMetaData = 'Protegé tu Bici o Monopatín estés donde estés con nuestro seguro de Movilidad.'
import webSalesOffersSettingService from '@/apps/shared/services/webSalesOffersSettings-service';

const routes: Array<RouteConfig> = [
    {
        path: "/movilidad/cotizarMovilidad",
        name: "cotizador-movilidad",
        component: tabTwoMobility,
        meta: {
            title: () => 'Movilidad urbana',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                }
            ]

        },
    },
    {
        path: "/movilidad/valorVehiculo",
        name: "movilidad-range-view",
        component: tabThreeRange,
        meta: {
            title: () => 'Valor del vehiculo',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                }
            ]
        },
    },
    {
        path: "/movilidad/elegiPlan",
        name: "plans-view",
        component: tabFourPlans,
        meta: {
            title: () => 'Elegi el Plan',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                }
            ]
        },
    },
    {
        path: "/movilidad/datosCliente",
        name: "UrbanMobilityClientData",
        component: clientData,
        meta: {
            title: () => 'Datos personales',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                }
            ]
        },
    },
    {
        path: "/movilidad/finContrato",
        name: "UrbanMobilityFinalPayment",
        component: FinalPayment,
        meta: {
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                }
            ]
        },
        beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
            // Verificar si hay query strings
            const { ParamId, ExternalIdentifier, ChannelId } = to.query as {
                ParamId?: string;
                ExternalIdentifier?: string;
                ChannelId?: string;
            };

            // Si llega alguno de los tres parámetros, se guarda en sessionStorage
            if (ParamId || ExternalIdentifier || ChannelId) {
                if (ParamId) {
                    sessionStorage.setItem("ParamId", ParamId);
                }
                if (ExternalIdentifier) {
                    sessionStorage.setItem("PricingId", ExternalIdentifier);
                }
                if (ChannelId) {
                    sessionStorage.setItem("ChannelId", ChannelId);
                }
                sessionStorage.setItem("ExitOrContinueModal", "false");

                const timeStart = new Date();
                sessionStorage.setItem("TimeStartPaymentComplete", JSON.stringify(timeStart));

                // Redirigimos a la misma ruta SIN query para limpiarla
                next({ path: to.path, query: {} });
            } else {
                // Si no hay query params, seguimos normalmente
                next();
            }        
        }
    },
    {
        path: "/movilidad/resumen",
        name: "UrbanMobilitySummary",
        component: urbanMobilitySummary,
        meta: {
            title: () => 'Resumen',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
    },
    {
        path: "/movilidad/elegiPlan/:subpath",
        name: "tabFour",
        component: tabFourPlans,
        props: (route) => {
            return {
                offer: route.params.offer
            };
        },
        meta: {
            title: () => 'Elegi el Plan',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                }
            ]
        },
        beforeEnter: async (to: any, from: any, next: any): Promise<void> => {
            NF.UI.Page.block();
            try {
                const subpath = to.fullPath.split('/').pop();
                const actualPath = 'movilidad/elegiPlan';
                const response = await webSalesOffersSettingService.getWebSalesOffersSettings(subpath, actualPath);
                if (response?.pageCustomization) {
                    let pageCustomization = typeof response.pageCustomization === 'string'
                        ? JSON.parse(response.pageCustomization) : null;

                    if (Object.keys(pageCustomization).length > 0) {
                        to.params.offer = {
                            OffersSettings: response.pageCustomization
                        };
                        sessionStorage.setItem("rutaAlternativa", to.fullPath);
                        next();
                    } else {
                        next({ name: 'not-found' });
                    }
                } else {
                    next({ name: 'not-found' });
                }
            }
            catch {
                next({ name: 'not-found' });
            } finally {
                NF.UI.Page.unblock();
            }
        },
    },
    // Ruta comodín debe ir al final siempre
    {
        path: "/movilidad/:subpath*",
        name: "tabOne",
        component: tabOneWelcome,
        meta: {
            title: () => 'Datos personales',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                }
            ]
        },
        beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
            const { utm_source } = to.query as { utm_source?: string };            

            const existente = sessionStorage.getItem("Referente");
            if (!existente) {
                if (utm_source) {
                    sessionStorage.setItem("Referente", utm_source);
                }
                else {
                    if (document.referrer != '') {
                        sessionStorage.setItem("Referente", document.referrer);
                    }
                    else {
                        sessionStorage.setItem("Referente", null);
                    }
                }
            }

            const { utm_medium } = to.query as { utm_medium?: string };

            const existente_medium = sessionStorage.getItem("Medium");
            if (!existente_medium) {
                if (utm_medium) {
                    sessionStorage.setItem("Medium", utm_medium);
                }
                else {
                    sessionStorage.setItem("Medium", 'organic');
                }
            }

            if (Object.keys(to.query).length > 0) {
                next({ path: to.path, query: {} });
            } else {
                next();
            }
        }
    },
];

export default routes;